// IMPORTS
import _ from 'lodash'
import axios from 'axios'
import mobiscroll from '@mobiscroll/javascript'

// DEFINITIONS
const apiCatalogoLoadup = 'catalogo/loadup'

const state = {
	contenidos: [], 
	comunicados: [], 
    promociones: [], 
    productos: [], 
    productos_has_imagenes: [], 
    banners: [],
    appCFGs: {
        whatsapp: null,
        openPaySllowStorePayments: null,
    } 
}


const getters = {
    catalogosGetContenidos:             state => {return state.contenidos},
    catalogosGetComunicados:            state => {return state.comunicados},
    catalogosGetPromociones:            state => {return state.promociones},
    catalogosGetProductos:              state => {return state.productos},
    catalogosGetProductosHasImagenes:   state => {return state.productos_has_imagenes},
    catalogosGetBanners:                state => {return state.banners},
    catalogosGetAppCFGs:                state => {return state.appCFGs},
    catalogosGetConfigs:                state => {return state.configs},
}

const mutations = {
	_catalogosSet: (state, payload) => {
        _.forEach(('contenidos,comunicados,promociones,productos,productos_has_imagenes,banners,appCFGs,configs').split(','), keyName => {
            state[keyName] = _.clone(payload[keyName])
        })
    }
}

const actions = {
    catalogosGetProductById: ({getters}, payload) => {
        let found = {}
        try {
            found = _.find(getters.catalogosGetProductos, {id: payload})
            if(!found){
                throw 'Error localizando el producto solicitado';
            }
        } catch(e) {
            console.error(e)
            mobiscroll.snackbar({
                display: 'top',
                theme: 'ios',
                message: e,
                color: 'warning',
                duration: 7000
            })
        }
        return found;
    },
	catalogosLoadUp: async ({getters, commit}) => {
        try {
            let response = await axios.get(apiCatalogoLoadup)
            console.log("catalogosLoadUp", response)
            if(response.status){
                commit('_catalogosSet', response.data)
            }
        } catch(e){
            console.error(e)
            mobiscroll.snackbar({
                display: 'top',
                theme: 'ios',
                message: 'Ocurrió un error obteniendo la respuesta: ' + e,
                color: 'warning',
                duration: 7000
            })
        }
    }
}

// EXPORTS
export default {
	state,
	getters,
	mutations,
	actions
};